(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.wrapper = this;

      window.addEventListener('scroll', () => {
        if (window.scrollY > 10) {
          this.wrapper.classList.add('starbar-scrolled');
        } else {
          this.wrapper.classList.remove('starbar-scrolled');
        }
      }, { passive: true });
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
